import React from 'react';

interface Props {
  titre: string;
  description?: React.ReactNode;
}

/**
 * En-tête des pages de travail : le bandeau bleu pétrole de l'écran
 * d'arrivée, en plus compact. Toutes les pages ouvrent de la même façon :
 * même couleur, même taille de titre, même largeur que leur contenu.
 */
const EnTetePage: React.FC<Props> = ({ titre, description }) => (
  <div
    className="relative -mx-4 -mt-4 bg-[linear-gradient(165deg,#365B6D_0%,#2E5061_55%,#284756_100%)]
      px-4 text-white lg:-mx-8 lg:-mt-7 lg:px-8"
  >
    <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
      <div
        className="absolute -top-56 left-1/2 h-[440px] w-[900px] -translate-x-1/2 rounded-full
          bg-[radial-gradient(closest-side,rgba(108,146,134,0.4),transparent)]"
      />
    </div>
    <div className="relative mx-auto max-w-[1040px] pb-9 pt-10">
      <h1 className="text-[30px] font-semibold tracking-tight text-white sm:text-[34px]">{titre}</h1>
      {description && <p className="mt-2 max-w-[68ch] text-[15px] leading-relaxed text-white/75">{description}</p>}
    </div>
  </div>
);

export default EnTetePage;
